import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLimit } from "../features/filter/filterSlice";
import { fetchTransactions } from "./../features/transaction/transactionSlice";
import Form from "./Form";
import LoadingSpinner from "./LoadingSpinner";
import Transaction from "./Transaction";

const TransactionContainer = () => {
  const { transactions, editing, loading, error } = useSelector((state) => state.transaction);
  const filter = useSelector((state) => state.filter);
  const { id } = editing;
  const { isLoading, loadingType } = loading;
  const { errorMsg, isError } = error;
  const dispatch = useDispatch();
  const [editingMode, setEditingMode] = useState(false);

  useEffect(() => {
    dispatch(setLimit(10));
    dispatch(fetchTransactions({ ...filter, limit: 10 }));
  }, [dispatch, filter]);

  useEffect(() => {
    if (id) {
      setEditingMode(true);
    } else {
      setEditingMode(false);
    }
  }, [id]);

  return (
    <>
      {isLoading && loadingType === "fetchTransactions" ? (
        <div className='loading-container'>
          <LoadingSpinner color='dark' size='lg' />
        </div>
      ) : isError ? (
        <p className='error'>{errorMsg}</p>
      ) : transactions.length > 0 ? (
        <div className='all-transactions'>
          {transactions.map((transaction) => (
            <Transaction transaction={transaction} key={transaction.id} />
          ))}
        </div>
      ) : (
        <p className='error'>No transaction found!</p>
      )}

      {editingMode && (
        <div className='edit-form-container'>
          <Form />
        </div>
      )}
    </>
  );
};

export default TransactionContainer;
